import { ContextAction } from '../types';
import type { NavbarState, NavbarStateAction } from './types';

export const navbarStateInitial = { defaultOpen: true };

export const navbarStateReducer = (
  state: NavbarState,
  action: NavbarStateAction
): NavbarState => {
  switch (action.type) {
    case ContextAction.setNavbarState:
      return { ...state, defaultOpen: action.payload };
    default:
      return state;
  }
};
